const React = require("react");

const ActionCreators = require("../actionCreators/FileTypeActionCreators.js");

const Colorizer = require("../Colorizer.js");
const FileType = require("../types/FileType.js");

const FolderIcon = require("./FolderIcon.jsx");

const styles = {
    Normal: {
        Icon: {
            display: "block",
            fontSize: 71,
            marginBottom: 10,
            textShadow: "0 3px 5px #bbb",
            cursor: "pointer"
        },
        Figure: {
            textAlign: "center"
        },
        IconWrapper: {
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "center",
            width: 65
        }
    }
};

styles.Hover = {
    Icon: Object.assign({}, styles.Normal.Icon, {
        position: "relative",
        top: -2,
        textShadow: "0 8px 10px #999"
    }),
    Figure: styles.Normal.Figure,
    IconWrapper: styles.Normal.IconWrapper
};

const FileTypeItem = React.createClass({
    propTypes: {
        FileType: FileType.Type.isRequired
    },
    getInitialState() {
        return {
            IsHovering: false
        };
    },
    render() {
        const styleSet =
            this.state.IsHovering
            ? styles.Hover
            : styles.Normal;

        const figureStyle = Object.assign({}, (this.props.style || {}), styleSet.Figure);
        
        const iconColor = Colorizer.ForNumber(this.props.FileType.PKID);

        const iconStyle = Object.assign({}, styleSet.Icon, {
            color: iconColor
        });

        return (<figure style={figureStyle}>
            <div style={styleSet.IconWrapper} onMouseOver={this.MouseOver} onMouseOut={this.MouseOut}
                 onClick={this.Click}>
                <FolderIcon style={iconStyle} />
            </div>
            {this.props.FileType.DisplayName}
        </figure>);
    },
    MouseOver() {
        this.setState({ IsHovering: true });
    },
    MouseOut() {
        this.setState({ IsHovering: false });
    },
    Click() {
        ActionCreators.Select(this.props.FileType);
    }
});

module.exports = FileTypeItem;


// WEBPACK FOOTER //
// ./src/components/FileTypeItem.jsx